import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox } from "vue";
const _hoisted_1 = { class: "content-builder avatar-conversation-builder" };
const _hoisted_2 = {
    key: 0,
    class: "alert alert-warning py-2"
};
const _hoisted_3 = {
    key: 1,
    class: "alert alert-info py-2"
};
const _hoisted_4 = { class: "config-section" };
const _hoisted_5 = { class: "section-heading" };
const _hoisted_6 = {
    key: 0,
    class: "muted-meta"
};
const _hoisted_7 = { class: "section-panel character-panel" };
const _hoisted_8 = { class: "portrait" };
const _hoisted_9 = { class: "portrait-frame" };
const _hoisted_10 = ["src", "alt"];
const _hoisted_11 = {
    key: 1,
    class: "portrait-empty"
};
const _hoisted_12 = {
    key: 2,
    class: "portrait-type"
};
const _hoisted_13 = {
    key: 0,
    class: "portrait-meta"
};
const _hoisted_14 = { class: "portrait-name" };
const _hoisted_15 = { class: "portrait-voice" };
const _hoisted_16 = { class: "character-fields" };
const _hoisted_17 = { class: "form-group mb-3" };
const _hoisted_18 = ["disabled"];
const _hoisted_19 = ["value"];
const _hoisted_20 = {
    key: 0,
    class: "form-group mb-0"
};
const _hoisted_21 = {
    class: "control-label",
    for: "voice-id"
};
const _hoisted_22 = {
    key: 0,
    class: "text-danger"
};
const _hoisted_23 = ["disabled"];
const _hoisted_24 = { value: "" };
const _hoisted_25 = ["value"];
const _hoisted_26 = {
    key: 2,
    class: "form-text text-muted mb-0"
};
const _hoisted_27 = {
    key: 3,
    class: "form-text text-muted mb-0"
};
const _hoisted_28 = {
    key: 1,
    class: "form-group mb-0"
};
const _hoisted_29 = { class: "config-section" };
const _hoisted_30 = { class: "section-panel mode-panel" };
const _hoisted_31 = {
    class: "mode-grid",
    role: "radiogroup",
    "aria-label": "Conversation mode"
};
const _hoisted_32 = {
    key: 0,
    class: "mode-note mb-0"
};
const _hoisted_33 = { class: "form-group mt-3 mb-0" };
const _hoisted_34 = { class: "config-section" };
const _hoisted_35 = { class: "section-panel assistant-panel" };
const _hoisted_36 = {
    key: 0,
    class: "helper-note helper-info mb-0"
};
const _hoisted_37 = {
    key: 1,
    class: "helper-note mb-0"
};
const _hoisted_38 = {
    key: 2,
    class: "helper-note helper-warning mb-0"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_voice_selector = _resolveComponent("voice-selector");
    const _component_assistant_selector = _resolveComponent("assistant-selector");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        ($data.catalogError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString($data.catalogError), 1))
            : _createCommentVNode("", true),
        ($data.catalogDisabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, " LiveAvatar is not configured here. Enter IDs manually; they are checked when a learner opens the page. "))
            : _createCommentVNode("", true),
        _createElementVNode("section", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
                _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "section-title" }, "Character", -1)),
                ($data.catalogLoading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Loading catalogue…"))
                    : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                        ($options.selectedAvatar?.preview_url)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: $options.selectedAvatar.preview_url,
                                alt: $options.selectedAvatar.name,
                                class: "portrait-image"
                            }, null, 8, _hoisted_10))
                            : (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[8] || (_cache[8] = [
                                    _createElementVNode("i", {
                                        class: "fa fa-user",
                                        "aria-hidden": "true"
                                    }, null, -1),
                                    _createElementVNode("span", null, "No avatar selected", -1)
                                ]))])),
                        ($options.selectedAvatar?.type)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString($options.selectedAvatar.type), 1))
                            : _createCommentVNode("", true)
                    ]),
                    ($options.selectedAvatar)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createElementVNode("strong", _hoisted_14, _toDisplayString($options.selectedAvatar.name), 1),
                            _createElementVNode("span", _hoisted_15, _toDisplayString($options.voiceSummary), 1)
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                        _cache[10] || (_cache[10] = _createElementVNode("label", {
                            class: "control-label",
                            for: "avatar-id"
                        }, "Avatar", -1)),
                        ($data.catalogDisabled)
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 0,
                                id: "avatar-id",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($data.content.avatar_id) = $event)),
                                class: "form-control",
                                type: "text",
                                placeholder: "Avatar ID"
                            }, null, 512)), [
                                [_vModelText, $data.content.avatar_id]
                            ])
                            : _withDirectives((_openBlock(), _createElementBlock("select", {
                                key: 1,
                                id: "avatar-id",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (($data.content.avatar_id) = $event)),
                                class: "form-control",
                                disabled: $data.catalogLoading
                            }, [
                                _cache[9] || (_cache[9] = _createElementVNode("option", { value: "" }, "Select an avatar…", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.avatars, (avatar) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                        key: avatar.id,
                                        value: avatar.id
                                    }, _toDisplayString(avatar.name), 9, _hoisted_19));
                                }), 128))
                            ], 8, _hoisted_18)), [
                                [_vModelSelect, $data.content.avatar_id]
                            ])
                    ]),
                    ($data.content.session_mode === 'FULL')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            _createElementVNode("label", _hoisted_21, [
                                _cache[11] || (_cache[11] = _createTextVNode(" Voice ", -1)),
                                ($options.voiceRequired)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, "*"))
                                    : _createCommentVNode("", true)
                            ]),
                            ($data.catalogDisabled)
                                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                    key: 0,
                                    id: "voice-id",
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (($data.content.voice_id) = $event)),
                                    class: "form-control",
                                    type: "text",
                                    placeholder: "Voice ID"
                                }, null, 512)), [
                                    [_vModelText, $data.content.voice_id]
                                ])
                                : _withDirectives((_openBlock(), _createElementBlock("select", {
                                    key: 1,
                                    id: "voice-id",
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (($data.content.voice_id) = $event)),
                                    class: "form-control",
                                    disabled: $data.catalogLoading
                                }, [
                                    _createElementVNode("option", _hoisted_24, _toDisplayString($options.voiceRequired ? 'Select a voice…' : 'Use avatar default'), 1),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.voices, (voice) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: voice.id,
                                            value: voice.id
                                        }, _toDisplayString($options.formatVoiceOption(voice)), 9, _hoisted_25));
                                    }), 128))
                                ], 8, _hoisted_23)), [
                                    [_vModelSelect, $data.content.voice_id]
                                ]),
                            ($options.voiceRequired)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_26, " Required for image avatars. "))
                                : ($options.selectedAvatar?.default_voice && !$data.content.voice_id)
                                    ? (_openBlock(), _createElementBlock("small", _hoisted_27, " Will use " + _toDisplayString($options.selectedAvatar.default_voice.name) + ". ", 1))
                                    : _createCommentVNode("", true)
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _cache[12] || (_cache[12] = _createElementVNode("label", { class: "control-label" }, "BLUE TTS voice", -1)),
                            _createVNode(_component_voice_selector, {
                                id: $data.content.ttsVoice.voiceName,
                                speed: $data.content.ttsVoice.speed,
                                "model-id": $data.content.ttsVoice.opts?.model_id,
                                stability: $data.content.ttsVoice.opts?.stability,
                                "similarity-boost": $data.content.ttsVoice.opts?.similarity_boost,
                                "style-exaggeration": $data.content.ttsVoice.opts?.style_exaggeration,
                                "use-speaker-boost": $data.content.ttsVoice.opts?.use_speaker_boost,
                                instructions: $data.content.ttsVoice.opts?.instructions,
                                "custom-pronunciations": $data.content.ttsVoice.opts?.custom_pronunciations,
                                "id-index": "avatar-lite",
                                onHandleVoiceChange: $options.handleTtsVoiceChange
                            }, null, 8, ["id", "speed", "model-id", "stability", "similarity-boost", "style-exaggeration", "use-speaker-boost", "instructions", "custom-pronunciations", "onHandleVoiceChange"])
                        ]))
                ])
            ])
        ]),
        _createElementVNode("section", _hoisted_29, [
            _cache[19] || (_cache[19] = _createElementVNode("h3", { class: "section-title" }, "Conversation mode", -1)),
            _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("label", {
                        class: _normalizeClass(["mode-option", { active: $data.content.session_mode === 'FULL' }])
                    }, [
                        _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => (($data.content.session_mode) = $event)),
                            class: "sr-only",
                            type: "radio",
                            name: "session_mode",
                            value: "FULL"
                        }, null, 512), [
                            [_vModelRadio, $data.content.session_mode]
                        ]),
                        _cache[13] || (_cache[13] = _createElementVNode("span", {
                            class: "mode-radio",
                            "aria-hidden": "true"
                        }, null, -1)),
                        _cache[14] || (_cache[14] = _createElementVNode("span", { class: "mode-body" }, [
                            _createElementVNode("span", { class: "mode-name" }, "FULL"),
                            _createElementVNode("span", { class: "mode-copy" }, "HeyGen hears and speaks")
                        ], -1))
                    ], 2),
                    _createElementVNode("label", {
                        class: _normalizeClass(["mode-option", { active: $data.content.session_mode === 'LITE' }])
                    }, [
                        _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => (($data.content.session_mode) = $event)),
                            class: "sr-only",
                            type: "radio",
                            name: "session_mode",
                            value: "LITE"
                        }, null, 512), [
                            [_vModelRadio, $data.content.session_mode]
                        ]),
                        _cache[15] || (_cache[15] = _createElementVNode("span", {
                            class: "mode-radio",
                            "aria-hidden": "true"
                        }, null, -1)),
                        _cache[16] || (_cache[16] = _createElementVNode("span", { class: "mode-body" }, [
                            _createElementVNode("span", { class: "mode-name" }, "LITE"),
                            _createElementVNode("span", { class: "mode-copy" }, "BLUE TTS + avatar lip-sync")
                        ], -1))
                    ], 2)
                ]),
                ($data.content.session_mode === 'LITE')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_32, " LITE settings are saved, but learner sessions still run in FULL for now. "))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_33, [
                    _withDirectives(_createElementVNode("input", {
                        id: "avatar-allow-retry",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => (($data.content.allow_retry) = $event)),
                        class: "mr-1",
                        type: "checkbox"
                    }, null, 512), [
                        [_vModelCheckbox, $data.content.allow_retry]
                    ]),
                    _cache[17] || (_cache[17] = _createElementVNode("label", {
                        class: "control-label",
                        for: "avatar-allow-retry"
                    }, " Let learners restart the conversation ", -1)),
                    _cache[18] || (_cache[18] = _createElementVNode("p", { class: "mode-note mb-0" }, " Each restart opens a new billable session and replaces the saved transcript. ", -1))
                ])
            ])
        ]),
        _createElementVNode("section", _hoisted_34, [
            _cache[22] || (_cache[22] = _createElementVNode("h3", { class: "section-title" }, "Conversation assistant", -1)),
            _createElementVNode("div", _hoisted_35, [
                _createVNode(_component_assistant_selector, {
                    id: $data.content.assistantId,
                    type: "feedback",
                    label: "Assistant",
                    "single-character-only": "",
                    onHandleChange: $options.handleAssistantChange
                }, null, 8, ["id", "onHandleChange"]),
                ($options.repliesFromHeyGen)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_36, [...(_cache[20] || (_cache[20] = [
                            _createElementVNode("i", {
                                class: "fa fa-info-circle",
                                "aria-hidden": "true"
                            }, null, -1),
                            _createElementVNode("span", null, [
                                _createElementVNode("strong", null, "HeyGen's model writes the avatar's replies"),
                                _createTextVNode(" from this assistant's instructions. The model and settings configured on the assistant aren't used. ")
                            ], -1)
                        ]))]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_37, " Drives what the avatar says. A multi-character assistant with a scene package runs it through Game Changer. ")),
                ($data.selectedAssistant?.type !== 'feedback')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_38, [...(_cache[21] || (_cache[21] = [
                            _createElementVNode("i", {
                                class: "fa fa-exclamation-triangle",
                                "aria-hidden": "true"
                            }, null, -1),
                            _createElementVNode("span", null, " Multi-character assistants with more than one character don't appear in this list. HeyGen doesn't support conversations between multiple characters yet. ", -1)
                        ]))]))
                    : _createCommentVNode("", true)
            ])
        ]),
        _cache[23] || (_cache[23] = _createElementVNode("hr", { class: "page-type-divider" }, null, -1))
    ]));
}
